function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.516 18.3l-6.969-6.843C2.463 11.382 0 9.087 0 6.363 0 3.027 2 1 5.337 1 7.295 1 9.116 2.566 10 3.456 10.884 2.566 12.716 1 14.663 1 18 1 20 2.995 20 6.363c0 2.735-2.453 5.019-2.558 5.116l-6.958 6.82a.686.686 0 01-.968 0z",
  fill: "currentcolor",
  fillRule: "nonzero"
});
function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgHeartActive;